<template>
  <UDropdownMenu
    v-model:open="isProfileExpanded"
    :items="profileItems"
    :ui="{
      content: 'w-48',
    }"
  >
    <UButton
      class="p-0"
      color="secondary"
      variant="ghost"
    >
      <template #default>
        <div class="hidden sm:flex flex-col justify-end items-end">
          <span class="text-xs font-normal text-muted"> ยินดีต้อนรับ </span>
          <span class="text-base font-semibold">
            {{ user?.first_name }} {{ user?.last_name }}
          </span>
        </div>
        <UAvatar :alt="[user?.first_name, user?.last_name].join(' ')" />
      </template>
      <template #trailing>
        <UIcon
          class="shrink-0 size-3 m-1"
          :class="[
            'transition-transform duration-200',
            { 'rotate-180': isProfileExpanded },
          ]"
          name="i-lucide-chevron-down"
        ></UIcon>
      </template>
    </UButton>
  </UDropdownMenu>
</template>

<script lang="ts" setup>
import type { DropdownMenuItem } from "@nuxt/ui";

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const isProfileExpanded = ref(false);
const profileItems = computed<DropdownMenuItem[][]>(() => [
  [
    {
      label: "ออกจากระบบ",
      icon: "i-lucide-log-out",
      to: { name: "auth-logout" },
    },
  ],
]);
</script>

<style></style>
